import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Dashboard.css';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';

const Dashboard = () => {
  const [user, setUser] = useState({
    name: '',
    email: '',
    mobile: '',
    city: '',
    state: '',
    pinCode: '',
  });
  const [productRequirements, setProductRequirements] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [productName, setProductName] = useState('');
  const [productImage, setProductImage] = useState('');
  const [productDescription, setProductDescription] = useState('');
  
  const [PCity, setPCity] = useState('');  // Add this line to define `city` state
  const [activeMenu, setActiveMenu] = useState('profile'); // State to track the active menu item

  const navigate = useNavigate(); // Use useNavigate for navigation

  // Get user data from localStorage (after OTP verification)
useEffect(() => {
  const storedUser = localStorage.getItem('user');

  if (storedUser) {
    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(storedUser);
    const isMobile = /^\d{10}$/.test(storedUser); // Adjust if mobile format varies

    setUser(prevUser => ({
      ...prevUser,
      email: isEmail ? storedUser : '',
      mobile: isMobile ? storedUser : ''
    }));
  } else {
    navigate('/');
  }
}, []);


  // Handle saving profile changes
  const handleSaveProfile = () => {
    // Send profile data to API (e.g., backend server)
    axios.post('https://api.lbnhyderabad.com/auth-mp/api/saveProfile', user)
      .then(response => {
        alert('Profile updated successfully!');
        setIsEditing(false);
      })
      .catch(error => alert('Error updating profile'));
  };

  // Handle adding product requirement
const handleAddProductRequirement = () => {
  const storedUser = localStorage.getItem('user'); // userIdentifier

  if (!storedUser) {
    alert('User not logged in');
    return;
  }

  if (!productName) {
    alert('Please enter product name');
    return;
  }

  const formData = new FormData();
  formData.append('userIdentifier', storedUser);
  formData.append('productName', productName);
  formData.append('city', PCity);
  formData.append('productDescription', productDescription);
  if (productImage) {
    formData.append('productImage', productImage);
  }

  axios.post('https://api.lbnhyderabad.com/auth-mp/api/saveProductRequirement', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
    .then(response => {
      alert(response.data.message);
      setProductName('');
      setProductImage(null);
      setPCity('');
      setProductDescription('');
    })
    .catch(error => {
      alert('Error adding product requirement');
      console.error(error);
    });
};

useEffect(() => {
  if (activeMenu === 'myProducts') {
    const storedUser = localStorage.getItem('user');

    if (!storedUser) {
      alert('User not logged in');
      return;
    }

    axios.get('https://api.lbnhyderabad.com/auth-mp/api/getProductRequirements', {
      params: { userIdentifier: storedUser }
    })
      .then(response => {
        setProductRequirements(response.data);
            console.log(response.data)
      })

  
      .catch(error => {
        console.error('Error fetching products:', error);
      });
  }
}, [activeMenu]);


  return (
    <div className="dashboard">

   
      <div className="dashboard-content">
        <div className="dashboard-menu">
       <ul>
  <li className={activeMenu === 'profile' ? 'active' : ''} onClick={() => setActiveMenu('profile')}>
    <i className="fas fa-user"></i> Edit Profile
  </li>
  <li className={activeMenu === 'product' ? 'active' : ''} onClick={() => setActiveMenu('product')}>
    <i className="fas fa-box"></i>Product Requirement
  </li>
  <li className={activeMenu === 'myProducts' ? 'active' : ''} onClick={() => setActiveMenu('myProducts')}>
    <i className="fas fa-th-list"></i> My Products
  </li>
</ul>

        </div>

        <div className="dashboard-right-content">
          {activeMenu === 'profile' && (
            <div className="user-card">
              <h2>Profile</h2>
              <div className="user-info">
                {!isEditing ? (
                  <>
                    <p><strong>Name:</strong> {user.name || 'N/A'}</p>
                    <p><strong>Email:</strong> {user.email}</p>
                    <p><strong>Mobile:</strong> {user.mobile}</p>
                    <p><strong>City:</strong> {user.city}</p>
                    <p><strong>State:</strong> {user.state}</p>
                    <p><strong>Pin Code:</strong> {user.pinCode}</p>
                    <button className="edit-btn" onClick={() => setIsEditing(true)}>Edit Profile</button>
                  </>
                ) : (
                  <div className="edit-profile-form">
                      <div class="input-row">
                    <input
                      type="text"
                      placeholder="Name"
                      value={user.name}
                      onChange={(e) => setUser({ ...user, name: e.target.value })}
                    />
                    <input
                      type="text"
                      placeholder="Mobile"
                      value={user.mobile}
                      onChange={(e) => setUser({ ...user, mobile: e.target.value })}
                    />
                    </div>
                           <div class="input-row">
                    <input
                      type="email"
                      placeholder="Email"
                      value={user.email}
                      onChange={(e) => setUser({ ...user, email: e.target.value })}
                    />
                    <input
                      type="text"
                      placeholder="City"
                      value={user.city}
                      onChange={(e) => setUser({ ...user, city: e.target.value })}
                    />
                         </div>
                           <div class="input-row">
                    <input
                      type="text"
                      placeholder="State"
                      value={user.state}
                      onChange={(e) => setUser({ ...user, state: e.target.value })}
                    />
                    <input
                      type="text"
                      placeholder="Pin Code"
                      value={user.pinCode}
                      onChange={(e) => setUser({ ...user, pinCode: e.target.value })}
                    />
                     </div>
    <div className="button-container">
  <button className="save-btn" onClick={handleSaveProfile}>Save</button>
  <button className="cancel-btn" onClick={() => setIsEditing(false)}>Cancel</button>
</div>
   </div>
                )}
              </div>
            </div>
          )}

{activeMenu === 'product' && (
  <div className="product-requirement">
    <h2>Add Product Requirement</h2>

    {/* Two inputs in a row */}
    <div className="input-row">
      <input
        type="text"
        placeholder="Product Name"
        value={productName}
        onChange={(e) => setProductName(e.target.value)}
      />
  <input
  type="file"
  accept="image/*"
  onChange={(e) => setProductImage(e.target.files[0])}
/>

    </div>

    {/* City Input */}
    <input
      type="text"
      placeholder="City"
      value={PCity}
      onChange={(e) => setPCity(e.target.value)}
    />

    <textarea
      placeholder="Product Description"
      value={productDescription}
      onChange={(e) => setProductDescription(e.target.value)}
    />

    <button className="submit-btn" onClick={handleAddProductRequirement}>Submit</button>
  </div>
)}


          {activeMenu === 'myProducts' && (
            <div className="my-product-requirements">
              <h2>My Product Requirements</h2>
              {productRequirements.length > 0 ? (
                <div className="product-list">
                  {productRequirements.map((product, index) => (
                    <div key={index} className="product-card">
                      <h3>{product.product_name}</h3>
                      <img src={product.product_image} alt={product.productName} />
                      <p>{product.product_description}</p>
                    </div>
                  ))}
                </div>
              ) : (
                <p>No product requirements added yet.</p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
